/**
 * Created by RaoMeng on 2020/10/30
 * Desc: 拜访记录列表
 */

import React, { Component } from 'react'
import ReactDOM from 'react-dom'
import { PullToRefresh, ListView, Toast } from 'antd-mobile'
import { connect } from 'react-redux'
import LoadingMore from '../../components/LoadingMore'
import { fetchGet } from '../../utils/fetchRequest'
import { API } from '../../configs/api.config'
import VisitRecordItem from '../../components/VisitRecordItem'
import { getSearchParams, isObjEmpty } from '../../utils/common'
import { saveListState } from '../../redux/actions/listState'

const mPageSize = 20
let mPageIndex = 0
let recordList = []

class VisitList extends Component {

  constructor () {
    super()

    this.state = {
      refreshing: true,
      hasNextPage: true,
      height: document.documentElement.clientHeight,
      visitDataSource: new ListView.DataSource({
        rowHasChanged: (row1, row2) => row1 !== row2,
      }),
    }
  }

  componentDidMount () {
    document.title = '拜访记录'
    this.searchParams = getSearchParams(this.props.location.search)
    const hei = this.state.height - ReactDOM.findDOMNode(this.lv).offsetTop
    this.setState({
      height: hei,
      refreshing: false,
    })

    if (this.props.listState && !isObjEmpty(this.props.listState.listData)) {
      mPageIndex = this.props.listState.pageIndex
      this.setState({
          visitDataSource: this.props.listState.listData,
          hasNextPage: this.props.listState.hasNextPage,
        },
        () => {
          ReactDOM.findDOMNode(
            this.lv).scrollTop = this.props.listState.scrollTop
          if (this.state.hasNextPage) {
            this.loadVisitList()
          }
        },
      )
    } else {
      Toast.loading('加载中...', 0)
      recordList = []
      mPageIndex = 0
      this.loadVisitList()
    }
  }

  componentWillUnmount () {

  }

  render () {
    const { refreshing, visitDataSource, height, hasNextPage } = this.state
    return (
      <div className='common-column-layout'
      >
        <ListView
          ref={el => this.lv = el}
          dataSource={visitDataSource}
          initialListSize={mPageSize}
          renderFooter={() => {
            return hasNextPage && <LoadingMore/>
          }}
          renderRow={(rowData, sectionID, rowID) => {
            return <VisitRecordItem
              visitRecord={rowData}
              onRecordClick={this.onRecordClick.bind(this)}/>
          }}
          style={{
            height,
          }}
          pullToRefresh={<PullToRefresh
            refreshing={refreshing}
            onRefresh={() => {
              this.setState({
                refreshing: true,
              })
              mPageIndex = 0
              recordList = []
              this.loadVisitList()
            }}
          />}
          onEndReachedThreshold={10}
          onEndReached={hasNextPage ? this.loadVisitList : null}
          pageSize={20}
        />
      </div>
    )
  }

  loadVisitList = () => {
    if (isObjEmpty(this.searchParams.openid, this.searchParams.appId)) {
      Toast.fail('参数缺失')
      return
    }

    mPageIndex++
    if (mPageIndex === 1) {
      this.setState({
        visitDataSource: new ListView.DataSource({
          rowHasChanged: (row1, row2) => row1 !== row2,
        }),
      })
    }

    fetchGet(API.VISIT_RECORD_LIST, {
      openid: this.searchParams.openid,
      appId: this.searchParams.appId,
      number: mPageIndex,
      size: mPageSize,
    }).then(response => {
      Toast.hide()
      if (!isObjEmpty(response.data) && !isObjEmpty(response.data.list)) {
        recordList = recordList.concat(response.data.list)
        this.setState({
          visitDataSource: this.state.visitDataSource.cloneWithRows(recordList),
          hasNextPage: response.data.hasNextPage,
          refreshing: false,
        })
      } else {
        if (mPageIndex > 1) {
          mPageIndex--
        }
      }
    }).catch(error => {
      Toast.hide()

      if (mPageIndex > 1) {
        mPageIndex--
      }
      if (typeof error === 'string') {
        Toast.fail(error, 2)
      } else {
        Toast.fail('请求异常')
      }

      this.setState({
        refreshing: false,
      })
    })
  }

  onRecordClick = (visitRecord) => {
    saveListState({
      scrollTop: ReactDOM.findDOMNode(this.lv).scrollTop,
      listData: this.state.visitDataSource,
      pageIndex: mPageIndex,
      hasNextPage: this.state.hasNextPage,
    })()
    this.props.history.push('/visitDetail/' + visitRecord.id)
  }
}

let mapStateToProps = (state) => ({
  listState: { ...state.redListState },
})

let mapDispatchToProps = (dispatch) => ({})

export default connect(mapStateToProps, mapDispatchToProps)(VisitList)
